import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getTranslation } from './language'

const resources = { ...getTranslation('th'), ...getTranslation('en') }

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
})

export default i18n
